export const selectAllTaxes = state => state.taxes.taxes
export const selectAllTaxesActive = state =>
  state.taxes.taxes?.filter((tax: Tax) => tax.active)
